/*
 * Discrete checkpoints in user flow.
 *
 * A checkpoint occurs when the frontend and backend successfully
 * compare their respective states against each other.
 */
export enum Checkpoint {
    SignedReturn = 0,
}
